<mat-card-header class="page-card-header">
  <mat-toolbar class="toolbar modern-toolbar">
    <div class="toolbar-title-container">
      <mat-icon class="header-icon">card_giftcard</mat-icon>
      <mat-card-title class="header-title">{{ 'listpassager' | translate }}</mat-card-title>
    </div>
    <span class="toolbar-spacer"></span>
    <button mat-mini-fab color="primary" class="cart-btn" title="Panier" [matBadge]="card?.length" matBadgePosition="after" matBadgeColor="warn" (click)="opencard()">
      <mat-icon>shopping_cart</mat-icon>
    </button>
  </mat-toolbar>
</mat-card-header>

<div class="container modern-container">
  <div class="search-container">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px" class="search-bar-row">
      <button mat-raised-button color="primary" class="btn-toggle-search" (click)="searchCriteria.showAdvanced = !searchCriteria.showAdvanced">
        <mat-icon>{{searchCriteria.showAdvanced ? 'expand_less' : 'tune'}}</mat-icon>
        <span>Recherche Avancée</span>
      </button>
      <app-table-config
        [displayedColumns]="displayedColumns"
        [allColumns]="allColumns"
        (columnsChange)="displayedColumns = $event">
      </app-table-config>
    </div>

    <div *ngIf="searchCriteria.showAdvanced" class="advanced-search-panel modern-glass-panel">
      <div fxLayout="row wrap" fxLayoutGap="16px" class="search-fields">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Nom Passager</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input matInput [(ngModel)]="searchCriteria.nompassager" (ngModelChange)="onCriteriaChange()" placeholder="Ex: Jean">
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Contact</mat-label>
          <mat-icon matPrefix>phone</mat-icon>
          <input matInput [(ngModel)]="searchCriteria.contact" (ngModelChange)="onCriteriaChange()" placeholder="Ex: 699000000">
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>CNI</mat-label>
          <mat-icon matPrefix>badge</mat-icon>
          <input matInput [(ngModel)]="searchCriteria.cni" (ngModelChange)="onCriteriaChange()" placeholder="Ex: 100234">
        </mat-form-field>
      </div>
      
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="search-actions">
        <button mat-stroked-button color="warn" (click)="resetCriteria()">
          <mat-icon>restart_alt</mat-icon> Réinitialiser
        </button>
      </div>
    </div>
  </div>

  <div class="table-wrapper mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort class="modern-table">

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
        <td mat-cell *matCellDef="let element; let i=index;">
          <span class="index-chip">{{i+1}}</span>
        </td>
      </ng-container>

      <!-- Numero Column -->
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'numero' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <span class="code-pill">{{row.idpassager}}</span>
        </td>
      </ng-container>

      <!-- Nom Column -->
      <ng-container matColumnDef="nom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.name' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <div class="passenger-name-container">
            <span class="p-name">{{row.nompassager}}</span>
            <span class="p-ticket-tag" *ngIf="row.numticket">#{{row.numticket}}</span>
          </div>
        </td>
      </ng-container>

      <!-- Contact Column -->
      <ng-container matColumnDef="contact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.phone' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <span class="contact-text"><mat-icon class="cell-icon">phone</mat-icon> {{row.contact}}</span>
        </td>
      </ng-container>

      <!-- CNI Column -->
      <ng-container matColumnDef="cni">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'form_fields.idcardnumber' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <span class="cni-text"><mat-icon class="cell-icon">badge</mat-icon> {{row.cni || '—'}}</span>
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{'action' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="action-buttons-group">
            <ng-container *ngIf="userprivileges[6].state">
              <button mat-icon-button color="primary" (click)="editPassenger(element)" title="Modifier">
                <mat-icon>edit</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="userprivileges[6].state">
              <button mat-icon-button class="print-icon-btn" (click)="printPassengerTrip(element)" title="Imprimer Voyage">
                <mat-icon>print</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="userprivileges[7].state">
              <button mat-icon-button color="warn" (click)="delete(element)" title="Supprimer">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr class="mat-row empty-row" *matNoDataRow>
        <td class="mat-cell empty-cell" [attr.colspan]="displayedColumns.length">
          <div class="empty-state-container">
            <mat-icon class="empty-icon">search_off</mat-icon>
            <p class="empty-text">Aucun passager trouvé.</p>
          </div>
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="example-element-row modern-table-row" mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="viewPassengerTrip(row)"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100, passengerlist?.totalElements]" (page)="nextPage($event)" [length]="passengerlist?.totalElements" showFirstLastButtons class="modern-paginator"></mat-paginator>
  </div>
</div>
